<shell-layout *ngIf="config" [error_identity]="true">
  <img class="m-auto" src="assets/img/errors/error__bridger.svg" alt="error" />
  <ui-text color="blue-500" size="h4" weight="semibold" align="center" class="mt-6">
    {{ config.errorTitle }}
  </ui-text>

  <ui-text class="mt-3" color="blue-300" align="center">
    {{ config.errorDescription }}
  </ui-text>

  <div class="flex justify-center mt-10">
    <ui-button (clicked)="closeModal()" type="primary" label="Ir a la página principal"></ui-button>
  </div>
</shell-layout>
